/* Scout audience cohort instrumentation — consent-gated, no personal data.
   For GA4 session segments: compare sessions containing scout_question_sent,
   sessions with only scout_opened, and sessions with neither event.
   Never interpret scout_session_observed as proof of non-usage.
*/
(() => {
  "use strict";
  if (window.__summitScoutCohortsV1) return;
  window.__summitScoutCohortsV1 = true;
  const PREFIX = "sl_scout_cohort_v1_";
  const canTrack = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof window.gtag === "function"; }
    catch (_) { return false; }
  };
  const TTL = 30 * 60 * 1000; // Reset the tab cohort after 30 minutes of inactivity.
  const refreshSession = () => {
    try {
      const last = Number(sessionStorage.getItem(PREFIX + "last_activity") || 0);
      if (last && Date.now() - last > TTL) {
        for (const key of ["opened","engaged","observed"]) sessionStorage.removeItem(PREFIX + key);
      }
      sessionStorage.setItem(PREFIX + "last_activity", String(Date.now()));
    } catch (_) {}
  };
  const get = key => { try { refreshSession(); return sessionStorage.getItem(PREFIX + key); } catch (_) { return null; } };
  const set = (key,value) => { try { sessionStorage.setItem(PREFIX + key,value); } catch (_) {} };
  const emit = (name,params={}) => { if(canTrack()) window.gtag("event",name,{event_category:"scout_audience",...params}); };
  const initialize = () => {
    if(!canTrack()) return;
    refreshSession();
    if(!get("observed")) {
      set("observed","1");
      emit("scout_session_observed");
    }
  };
  const engaged = stage => {
    if (!canTrack()) return;
    initialize();
    if (!get(stage)) {
      set(stage,"1");
      emit(stage === "opened" ? "scout_session_opened" : "scout_session_engaged");
    }
  };
  document.addEventListener("click",event => {
    const el = event.target instanceof Element ? event.target : null;
    if(el?.closest("[data-scout-mobile-open],[data-scout-expand],.scout-dock-v2")) engaged("opened");
  },{passive:true});
  document.addEventListener("submit",event => {
    const form=event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(".scout-dock-v2 [data-scout-form]")) return;
    if (!form.querySelector("[data-scout-input]")?.value?.trim()) return;
    engaged("engaged");
  },true);
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initialize,{once:true});
  else initialize();
  document.addEventListener("visitorConsentCollected",initialize);
})();
